module.exports = __webpack_public_path__ + "static/media/games.602bbf09.svg";